/* eslint-disable import/no-unused-modules */
export const strings = {
  MODAL_TITLE: "Create Custom Model",
  MODEL_TEXT_ONE:
    "You are about to create a custom model. You can view this custom model in the Models tab under Investments. By continuing here, you will be redirected to the Custom Model creation flow. We'll save your work on this Investment Proposal, so you can access it from the Proposals tab later.",
  MODEL_TEXT_TWO:
    "By continuing here, you will be redirected to the Custom Model creation flow.",
  MODEL_TEXT_THREE:
    "We'll save your work on this Investment Proposal, so you can access it from the Proposals tab later.",

  SHARE_PROPOSAL_TITLE: "Share Proposal",
  SHARE_PROPOSAL_DESCRIPTION:
    "Are you sure you want to share this proposal with the client? They will be able to view and accept the proposal.",
  CANCEL_BUTTON: "Cancel",
  SHARE_BUTTON: "Share",
} as const;
